import { render, staticRenderFns } from "./BaseInputAutocomplete.vue?vue&type=template&id=1445f4fe&"
import script from "./BaseInputAutocomplete.vue?vue&type=script&lang=js&"
export * from "./BaseInputAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1445f4fe')) {
      api.createRecord('1445f4fe', component.options)
    } else {
      api.reload('1445f4fe', component.options)
    }
    module.hot.accept("./BaseInputAutocomplete.vue?vue&type=template&id=1445f4fe&", function () {
      api.rerender('1445f4fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseInputAutocomplete.vue"
export default component.exports